import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Secuencia didáctica completa',
    desc: 'Apertura, desarrollo, cierre y evaluación'
  }, {
    title: 'Material fotocopiable',
    desc: 'Listo para entregar al alumno'
  }, {
    title: 'Planificación anual',
    desc: 'Cronograma y correlación con contenidos'
  }, {
    title: 'Actividades participativas',
    desc: 'Individuales, grupales y de campo'
  }, {
    title: 'Evaluaciones con clave',
    desc: 'Sin tener que armar las correcciones'
  }, {
    title: 'Optimizado para proyector',
    desc: 'Podés enseñar directamente desde el PDF'
  }, {
    title: 'Reutilizable todo el año',
    desc: 'No empezás de cero nunca más'
  }, {
    title: 'Contexto de obra real',
    desc: 'Casos prácticos del mercado laboral actual'
  }, {
    title: '4 Bonos estratégicos',
    desc: 'Evaluaciones, actividades, Excel y glosario'
  }, {
    title: 'Garantía de 7 días',
    desc: 'Sin preguntas ni formularios'
  }, {
    title: 'Acceso inmediato',
    desc: 'Descarga directa tras la compra'
  }, {
    title: 'Actualizaciones gratuitas',
    desc: 'Acceso de por vida al material'
  }];
  return <section className="py-12 bg-[#06140d] border-y border-[#1a3d2c]" data-id="element-147">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-148">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-149">
          ✅ TODOS LOS TOMOS INCLUYEN:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-150">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-[#0c241a]/50 transition-colors" data-id="element-151">
              <CheckCircle2 className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-152" />
              <div data-id="element-153">
                <span className="text-slate-200 font-bold text-[16px] block" data-id="element-154">
                  {item.title}
                </span>
                <span className="text-slate-400 text-sm" data-id="element-155">{item.desc}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}